import { Component, HostBinding, type OnInit } from '@angular/core';
import { ChatCoreBotComponent, type Message } from '@big-direkt/chat-core';

@Component({
    selector: 'big-chat-bot',
    templateUrl: './bot.component.html',
    standalone: false,
})
export class BotComponent extends ChatCoreBotComponent implements OnInit {
    @HostBinding('class') public classList = 'flex flex-col h-full bg-gray-400';

    public override ngOnInit(): void {
        super.ngOnInit();

        if (this.messages.length !== 0) {
            return;
        }

        const message: Message = this.messagesService.createMessage(true, this.chatService.currentConfig().bot.status?.start ?? '');
        this.messagesService.add(message);
    }
}
